"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactSizeme = require("react-sizeme"),
    _Stage = _interopRequireDefault(require("./Stage")),
    _Dropdown = _interopRequireDefault(require("../../Dropdown")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _vars = require("../../../common/styles/vars");

require("../styles/_stages.scss");

var STAGE_MAX_WIDTH = 270;

function getStageMaxWidth(a, b) {
  return a / b > STAGE_MAX_WIDTH ? "".concat(STAGE_MAX_WIDTH, "px") : "calc(100% / ".concat(b, ")");
}

function getOnClickHandler(a, b) {
  return function () {
    return a(b);
  };
}

function getDropdownHandler(a) {
  return a ? function (b) {
    var c = b.value;
    return a(c);
  } : void 0;
}

function renderDropdownOption(a) {
  var b = a.stage,
      c = b.text,
      d = b.icon,
      e = a.currentStage,
      f = a.stageNumber,
      g = a.hideStageNumbers,
      h = a.color,
      i = void 0 === h ? "black" : h;
  return {
    label: _react["default"].createElement("span", {
      className: (0, _classnames["default"])("stages__mobile__label", {
        "stages__mobile__label--active": f === e
      })
    }, g ? c : "".concat(f, ". ").concat(c)),
    value: f,
    prefix: _react["default"].createElement(_Icon["default"], {
      name: d,
      color: i
    })
  };
}

function Stages(a) {
  var b = a.stages,
      c = a.currentStage,
      d = void 0 === c ? 1 : c,
      e = a.hideStageNumbers,
      f = a.onClick;
  return _react["default"].createElement(_reactSizeme.SizeMe, null, function (a) {
    var c = a.size;
    return _react["default"].createElement("div", {
      className: "stages"
    }, c.width >= _vars.NUMERIC_MEDIA_SIZES.small ? _react["default"].createElement("div", {
      className: "stages__list"
    }, b.map(function (a, g) {
      var h = a.text,
          i = a.minText,
          j = a.subtitle,
          k = a.icon,
          l = a.disabled;
      return _react["default"].createElement(_Stage["default"], {
        key: h,
        containerWidth: c.width,
        maxWidth: getStageMaxWidth(c.width, b.length),
        stageNumber: g + 1,
        stageComplete: d >= g + 1,
        text: h,
        minText: i,
        subtitle: j,
        hideStageNumbers: e,
        icon: k,
        onClick: f ? getOnClickHandler(f, g + 1) : void 0,
        disabled: l
      });
    })) : _react["default"].createElement(_Dropdown["default"], {
      color: "white",
      className: "stages__mobile",
      value: renderDropdownOption({
        stage: b[d - 1],
        stageNumber: d,
        color: "white",
        currentStage: d,
        hideStageNumbers: e
      }),
      onChange: getDropdownHandler(f),
      upperCaseLabels: !0,
      options: b.map(function (a, b) {
        return renderDropdownOption({
          stage: a,
          currentStage: d,
          stageNumber: b + 1,
          hideStageNumbers: e
        });
      })
    }));
  });
}

var _default = (0, _react.memo)(Stages);

exports["default"] = _default;